import React, { FC } from 'react';
import Spinner from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Spinner';
import Button from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Button';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';
import { getInstantCheckoutErrorModal } from 'constants/modals/instantCheckoutErrorModals';
import { navigateTo } from 'utils/location';
import useInstantCheckout from './useInstantCheckout';

import styles from './InstantCheckoutModalContent.module.scss';

export type InstantCheckoutModalContentProps = {
  location: string;
  regularCheckoutDestination: string;
};

const InstantCheckoutModalContent: FC<InstantCheckoutModalContentProps> = ({
  location,
  regularCheckoutDestination,
}) => {
  const { trackEvent } = useAnalytics();
  const { handleInstantCheckout, loading } = useInstantCheckout(
    location,
    getInstantCheckoutErrorModal,
  );
  return (
    <div className={styles.wrapper}>
      <div className={styles.content} aria-hidden={loading}>
        Check out in seconds with Instant Checkout - or check out as normal to shop your missed
        favourites, add vouchers and more
      </div>
      <div className={styles.buttons} aria-hidden={loading}>
        <Button
          label="Check out as normal"
          theme="secondary"
          disabled={loading}
          onClick={() => {
            trackEvent({
              event: 'review_checkout_click',
              instant_checkout: {
                location,
              },
            });
            navigateTo(regularCheckoutDestination);
          }}
        />
        <Button
          label="Instant checkout"
          theme="primary"
          disabled={loading}
          onClick={handleInstantCheckout}
        />
      </div>
      {loading && (
        <div className={styles.spinner}>
          <Spinner isActive ariaTextActive="Loading... Waiting for instant checkout to finish" />
        </div>
      )}
    </div>
  );
};

export default InstantCheckoutModalContent;
